import { ExerciseTODO } from "@/types";
import dayjs from "dayjs";
import NoItem from "@/components/NoItem.tsx";
import ExerciseItem from "@/components/exercises/ExerciseItem.tsx";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter.js";
import { t } from "i18next";

dayjs.extend(isSameOrAfter);

interface TodoListProps {
  deadline: boolean;
  exercises: ExerciseTODO[];
}

const isCloseToDeadline = (exercise: ExerciseTODO) => {
  const deadline = dayjs(exercise.toDoBy);
  const today = dayjs();
  return deadline.isSameOrAfter(today);
};

const TodoList = ({ exercises, deadline }: TodoListProps) => {
  const hasNewExercises = exercises.some((exercise) => exercise.isNew);
  const filteredAndSortedExercises = hasNewExercises
    ? exercises
    : exercises
        .filter((exercise) => !deadline || isCloseToDeadline(exercise))
        .sort((a, b) => {
          if (deadline) {
            return dayjs(a.toDoBy).diff(dayjs(b.toDoBy));
          }
          return dayjs(b.toDoBy).diff(dayjs(a.toDoBy));
        });

  return (
    <>
      {filteredAndSortedExercises?.map((exercise, index) => (
        <ExerciseItem
          key={`index-${index}-${exercise.id}`}
          status="todo"
          exercise={exercise}
          canBookWritings={false}
        />
      ))}

      {!exercises ||
        (exercises && exercises.length === 0 && (
          <NoItem
            text={t("home.course.no_exercise_msg", {
              defaultValue: "Exercises not available",
            })}
          />
        ))}
    </>
  );
};

export default TodoList;
